import {
  CUSTOMER_ACCOUNT_AGREEMENT_DESER,
  CustomerAccountAgreement,
  type PublicDocument,
} from "../../tastyworks/document"
import type HttpClient from "../../tastyworks/http"
import {
  parseItemsResponse,
  type ItemsResponse,
} from "../../tastyworks/response"

export class CustomerAccountAgreementService {
  constructor(private readonly customerMeClient: HttpClient) {}

  readonly index = async (): Promise<ItemsResponse<CustomerAccountAgreement>> =>
    this.customerMeClient.indexSimple(
      CUSTOMER_ACCOUNT_AGREEMENT_DESER.toParser(CustomerAccountAgreement),
      "customer-account-agreements"
    )

  readonly create = async (
    agreements: PublicDocument[],
    accountNumber?: string
  ): Promise<ItemsResponse<CustomerAccountAgreement>> => {
    const body: Record<string, unknown> = {
      "acceptance-method": "Click",
      agreements,
    }
    if (accountNumber) {
      body["account-number"] = accountNumber
    }
    return this.customerMeClient
      .postJson("customer-account-agreements", body)
      .then((helper) =>
        parseItemsResponse(
          helper,
          CUSTOMER_ACCOUNT_AGREEMENT_DESER.toParser(CustomerAccountAgreement)
        )
      )
  }
}
